export class Enfant {
    nom: string;
    prenom: string;

    pasEncoreNe: boolean;

    naissance: Date;
    genre: string;
    
    handicap: boolean;

    constructor() {
        this.pasEncoreNe = false;
    }
}